// extracted by mini-css-extract-plugin
export default {"wrapper":"TableGroup_wrapper__GhVw5","item":"TableGroup_item__sMwpk"};